import RouteConstant from "./RouteConstant";

export const MAX_WIDTH = 520;

export const VERIFY_ACTIONS = {
  RESET_PW: 'resetPassword',
};

export const API_KEY_1INCH = "mKijlbCA6RhRhxu2eKJO1m0pXk4KRv8l";
export const DEFAULT_TOKEN_ADDRESS = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';
export const DEFAULT_1INCH_SWAP_SLIPPAGE = 10;

export const secondarySideBarWidth = 215;
export const secondarySideBarGap = 80;

export const DEFAULT_WITHDRAW_PERCISION = 2;
export const DEFAULT_DEPOSIT_PERCISION = 2;

export const APPLY_CARD_TATUS_SUCCESS = 2;

export const INPUT_THROTTLE_MS = 500;

export const DEFAULT_FIAT_CURRENCY = 'USD';

export const BUSINESS_TYPE = {
  DEPT_PAYMENT_BUSINESS_TYPE: 60,
  DEPT_UN_PAYMENT_BUSINESS_TYPE: 59,
}

export const DEDUCT_TYPE = {
  DECLINE: 1,
  SMALL: 0
}

export const CARD_TRANS_STATUS = {
  PENDING: 'PENDING',
  CLEARED: 'CLEARED',
  DECLINED: 'DECLINED',
  CANCELED: 'CANCELED',
  REFUND: 'REFUND',
  VOID: "VOID",
}

export const CARD_TRANS_REFUND_STATUS = {
  PENDING: 1,
  SUCCESS: 2,
  FAIL: 3,
  CANCEL: 4,
}

export const RedotPayConstant = {
  TRANS_REFUND_STATUS_WAIT: 0,
  TRANS_REFUND_STATUS_PENDING: 1,
  TRANS_REFUND_STATUS_PASS: 2,
  TRANS_REFUND_STATUS_REJECT: 3,
};

export const CARD_SHIP_STATUS = {
  TO_USER: 'hasMailed',
  TO_CENTER: 'hasShipped',
  WAIT: 'toBeShipped',
};

export const THEMES = {
  LIGHT: "light",
  DARK: "dark"
};
export const lightTheme = theme => theme.palette.mode === "light";

export const WALLET_CONNECT_STATUS = {
  CONNECTED: 'connected',
  CONNECTING: 'connecting',
  DISCONNECTED: 'disconnected',
}

export const SUPPORT_VARIETY_LIST = [
  'usdc', 'usdt', 'btc', 'eth', 'bnb', 'doge', 'sol', 'shib'
]

export const DOC_TYPE = {
  PASSPORT: 'PASSPORT',
  ID_CARD: 'ID_CARD',
  DRIVERS: 'DRIVERS',
  RESIDENCE_PERMIT: 'RESIDENCE_PERMIT',
  SELFIE: 'SELFIE',
}

export const GUIDE_STEPS = {
  STEP_BIND_MOBILE: 1,
  STEP_KYC: 2,
  STEP_DEPOST: 3,
  STEP_BUY_CARD: 4,
}
export const GUIDE_PAGES = [
  RouteConstant.GUIDE_BIND_EMAIL,
  RouteConstant.GUIDE_BIND_MOBILE,
  RouteConstant.GUIDE_KYC,
  RouteConstant.GUIDE_DEPOSIT,
  RouteConstant.GUIDE_KYC_PRE,
  RouteConstant.GUIDE_BILL_ADDRESS,
]

export const MAIN_PAGES = [
  RouteConstant.MAIN,
  RouteConstant.HOME,
]

export const CUSTOMIZE_HEADER_PAGES = [
  RouteConstant.CARD_APPLY,
  RouteConstant.CARD_APPLY_ORDER,
  RouteConstant.CARD_MANAGEMENT,
  RouteConstant.CARD_MODIFY,
  RouteConstant.DEPOSIT_VARIETY_SELECT,
  RouteConstant.ASSETS_TRANS_LIST,
  RouteConstant.ASSETS_TRANS_DETAIL,
  RouteConstant.SUCCESS,
  RouteConstant.USER_DEPOSIT,
  RouteConstant.USER_WITHDRAW,
  RouteConstant.USER_ADDRESS_LIST,
  RouteConstant.USER_ADDRESS_ADD,
  RouteConstant.WITHDRAW_LIST,
  RouteConstant.WITHDRAW_DETAIL,
  RouteConstant.MESSAGE_LIST
]

// arbitrum, goerli, mainnet, optimism, polygon, opBNB
export const SUPPORTED_CHAINS = [
  {id: 'arbitrum', name: 'Arbitrum One', chainId: 42161, icon: ''},
  // { id: 'mainnet', name: 'Ethereum Mainnet', chainId: 1, icon: '' },
  {id: 'bsc', name: 'BNB Smart Chain Mainnet', chainId: 56, icon: ''},
  {id: 'polygon', name: 'Polygon Mainnet', chainId: 137, icon: ''},
  {id: 'optimism', name: 'OP Mainnet', chainId: 10, icon: ''},
]

export const LINKS = {
  POLICY: 'https://www.redotpay.com/en/policy/',
  TERMS: 'https://www.redotpay.com/en/terms/',
}

export const KYC_STATUS = {
  KYC_STATUS_NOT_SUBMIT: 0,
  KYC_STATUS_SUBMITTED: 1,
  KYC_STATUS_APPROVED: 2,
  KYC_STATUS_REJECT: 3,
  KYC_STATUS_RESUBMITTED: 4,
  KYC_STATUS_SUBMIT_UP: 5,
  KYC_STATUS_REJECT_FINAL: 6,
}

/// KYC证件过期流程状态 0 待提交 1审核中 2审核通过 3审核失败 4取消 5超次数拒绝(3次) 6超时拒绝 7KYC终态拒绝
export const KYC_EXPIRE_STATUS = {
  NOT_SUBMITTED: 0,
  SUBMITTED: 1,
  APPROVED: 2,
  REJECT: 3,
  FAILED_LIMIT: 5,
  FAILED_OVERTIME: 6,
  FAILED_FINAL: 7,
}

export const CARD_TYPE = {
  CARD_TYPE_VIRTUAL: 1,
  CARD_TYPE_PHYSICAL: 2,
}

export const WEB3_OPT = {
  USDC_APPROVE: 'USDC_APPROVE',
  WRITE_CONTRACT: 'WRITE_CONTRACT',
  SIGN_MESSAGE: 'SIGN_MESSAGE',
}

export const WEB3_UNIT = {
  USDC_UNIT: 6,
}

export const INTERVAL = {
  CHECK_BUY_CARD: 3 * 1000, // 轮询购卡结果
  CHECK_DEPOSIT: 3 * 1000, // 轮询充值结果
}

export const BUY_CARD_STATUS = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  CANCELED: 'CANCELED',
}

export const CARD_REFUND_STATUS = {
  PENDING: 1,
  SUCCESS: 2,
  FAIL: 3,
}

// supported mcc svg resources.
export const SUPPORTED_MCC = [
  '7012', '5611', '7210', '8651', '5598', '8043', '5942', '8241', '5995', '7629', '5994', '7832', '5943', '9406', '8042', '5200', '5599', '7211', '7991', '7011', '7993', '0742', '7549', '6051', '5969', '5941', '5996', '5997', '5983', '5940', '2791', '5968', '9405', '4121', '5571', '7372', '8041', '7399', '5411', '4900', '7992', '0780', '7941', '9950', '5818', '7996', '4723', '7216', '4131', '5561', '4119', '5944', '5950', '5978', '5039', '5993', '4468', '5992', '5945', '8050', '9399', '8911', '7217', '4722', '5399', '7997', '5199', '7995', '5172', '9402', '7349', '7361', '8734', '7375', '5947', '2741', '8244', '5013', '4457', '5946', '1711', '5211', '4899', '8641', '9211', '7994', '5198', '5699', '7298', '7273', '4829', '5262', '5935', '5921', '5074', '5712', '6540', '5713', '8021', '5511', '4814', '7299', '4784', '5698', '7933', '4816', '1761', '5261', '7338', '8220', '5937', '7339', '7311', '5300', '5499', '7932', '7922', '5310', '7261', '5462', '7513', '5099', '5933', '5072', '5714', '5932', '1771', '5271', '8999', '9311', '4812', '7512', '5311', '5661', '8351', '4225', '4582', '5139', '5111', '7538', '8031', '7699', '7841', '5065', '5931', '1799', '7511', '7277', '6399', '7911', '7534', '5451', '5531', '6010', '5733', '4411', '5732', '6011', '7333', '4821', '7535', '5691', '2842', '5122', '4214', '7523', '7251', '1740', '5532', '7641', '5718', '6211', '5719', '5094', '6012', '5533', '7278', '5309', '4215', '5137', '5651', '5655', '5641', '7297', '5331', '5251', '5912', '5047', '5735', '8211', '5734', '5046', '5085', '7692', '7321', '1750', '7296', '5697', '5681', '4789', '7519', '7531', '5044', '5722', '5045', '5051', '5521', '8011', '5441', '4011', '5131', '7929', '8398', '5817', '7033', '7999', '7392', '5552', '8062', '7379', '5977', '5963', '8249', '5962', '5976', '7393', '7542', '7230', '7998', '5631', '7032', '5816', '5814', '4511', '5169', '0763', '9223', '5592', '5551', '8049', '5948', '5960', '5021', '7622', '7623', '1520', '5975', '5949', '9222', '8699', '5815', '5811', '5193', '8931', '7394', '5965', '8299', '5971', '7800', '7829', '5970', '7801', '5964', '7342', '8071', '5541', '4111', '7395', '8111', '5192', '5812', '6300', '5621', '8661', '8675', '1731', '5231', '5972', '5966', '5999', '5998', '7631', '6513', '5967', '7802', '5973', '5542', '4112', '8099', '7221', '5422', '5813'
];
export const SUPPORTED_MCC_NAME = [
  'wechatpay', 'alipay', ['pacific', 'coffee'], 'google', 'starbucks', 'uber', 'applepay', 'aeon', 'alibaba', 'amazon',
  'carrefour', 'didi', 'kfc', 'mcdonalds', 'microsoft', 'sony', 'taobao', 'tesla', 'zara', ['7', 'eleven'], 'rakuten',
  'uniqlo'
];

export const SUPPORTED_MCC_NAME_V2 = [
  '7_eleven',       'adobe',             'aeon',
  'alibaba',        'aliexpress',        'alipay',
  'alipayhk',       'alp',               'amazon',
  'apple',          'applepay',          'aspiegel_ltd',
  'azar',           'booking',           'brawl_stars',
  'bytedance',      'canva',             'careem',
  'carrefour',      'cloudflare',        'coursera',
  'deliveroo',      'didi',              'discord',
  'dubai_taxi',     'duolingo',          'ea_electronic_arts',
  'efootball',      'facebk',            'facebook',
  'food_panda',     'free_fire',         'garena',
  'google',         'google_one',        'grab',
  'grameenphone',   'hostinger',         'huawei',
  'hungerstation',  'jd',                'jingdong',
  'kfc',            'lawson',            'linkedin',
  'mcdonalds',      'meituan',           'metapay',
  'microsoft',      'myus',              'onlyfans',
  'pacific_coffee', 'paypal',            'pubgmobile',
  'rakuten',        'roblox',            'samsungelec',
  'seven-eleven',   'seven_eleven',      'shein',
  'shopify',        'snapchat',          'sony',
  'starbucks',      'starlink',          'tabby',
  'talabat',        'taobao',            'taobao',
  'telegram',       'temu',              'temu',
  'tencent_cloud',  'tesla',             'tiktok',
  'tradingviewv',   'trip',              'truecaller',
  'uber',           'uberdirect',        'ubr',
  'uniqlo',         'wechatpay',         'weixin',
  'wolt',           'www',               'x_corp',
  'yalla_ludo',     'youcan',            'youtube',
  'zara',           'zhongyidongjinron', 'zoom'
]

export const SUPPORTED_MCC_CODE_V2 = ["0763","1711_5074","1740","1750_7622_5111_5943","1761","1771_5039_5935","1799","4011","4111_5551_4457_4468","4112_4789","4119","4131_7511","4214_5592","4215","4511","4582_4723_4722","4784","4812_4814_4821","4816","4899_8046_5815_7832","5044_5946_7395_7221","5045_7394","5085","5094_5631","5139_7251_5661","5169_8734","5172","5192_2741","5193","5300","5311_7393_7011_7399_5021","5441","5462","5531_5993_5309_5732_5251_5200_5948_5211_5262_7699_5999_5933_5973_5941_5655_5972_5978_5931_5698","5532","5533_7534","5552","5571_5561_5598","5611_5691_5131","5641_8351","5699_7296_5641_5651_5137_5621","5714_7641_5712","5718","5722_5099_1731_5422_7629","5733_8929_5735","5734","5812_5811","5813","5814","5817_5816_5818","5912_5122","5937_5932","5940_7519","5942","5944_7631","5947_5451_5310_5997_5713_5681_5231_5950_5411_5499_5399","5949","5963_5271","5964_5965_5967_5960_5969_5966_5968_5962","5971_5970_7333","5975","5976_8031","5977_7298_5199_8050_2842","5983","5992_5261","5994_6051_2791_4829","5995_0742","5996","5998_7033","6011_6010","6399_6300","6540","7012","7032","7216_7210","7217","7230_5072_5697","7261","7276","7277_7392","7278","7297","7311","7338","7342","7349_5198","7361","7372","7375","7379","7513","7535_7531_7542","7538_8675_7512_5511_5521_5599_5013_7523_4121","7549","7623","7692","7802","7829_7993_7841","7911_8244_8220_8271_8299_8211_5051_8249","7922","7932_7800_9406","7933","7991","7992","7994","7995_7801","7996","7997","7998","7999","8021_8071","8043_8042","8049_8041_8011_8099_5047","8062","8351","8398_1520_5541","8641_7273_8699_8661","8911","8931","8999_6513_7339_6211","9211_7321_6012_9399_8111_8651_9402_9311_9405_4900","9223_9222","9702"]

export const TRANS_TYPE = {
  "WALLET_DEPOSIT": 1,  //充值
  "WALLET_WITHDRAW": 2, //提现
  "TRANSFER": 3, //  划转到其他账户
  "EXCHANGE": 4, //闪兑
  "REBATE_WITHDRAW": 5, //提现回扣
  "REBATE": 6,  //回扣
  "USER_CARD_APPLY": 7, //购卡


  "CARD_APPLY": 10, //
  "CARD_CONSUMPTION": 11,//卡片消费
  "CARD_APPLY_REFUND": 12, //卡片申请退款
  "MERCHANT_EXCHANGE": 13,
  "MERCHANT_CARD_APPLY": 14,
  "MERCHANT_CARD_RECHARGE": 15,
  "ACTIVITY_SHARE": 16,
  "ADVERT": 17,
  "EPAY": 18,
  "REFUSE_AUTHORIZATION": 59,

  //体验金
  "TYJ": 19,
  "EXPIRE_TYJ": 20,
  "VIP_UPGRADE": 21,
  "TRANSFER_INSITE": 22,
  "SAAS_BILL": 30,

  "REGISTER": 31,
  "ACTIVITY_LOTTERY": 32,
  "REFUND": 33,

  "REDEEM_CARD_DEPOSIT": 34,
  "BINANCE_PAY_DEPOSIT": 35,
  "GATE_REDEEM_CARD_DEPOSIT": 37
}

export const ORDER_STATUS = {
  UNPROCESSED: 0,
  PROCESSING: 1,
  SUCCESS: 2,
  FAIL: 3,
  CANCELED: 4
}

export const WITHDRAW_STATUS = {
  Waiting: 0,
  Pending: 1,
  Success: 2,
  Fail: 3,
  Canceled: 4,
}

export const WALLET_SIGN_TEXT = {
  // APPLY_WITHDRAW: 'Apply Withdraw',
  FREEZE_CARD: 'Freeze Card',
  UNFREEZE_CARD: 'Unfreeze Card',
  SIGN_IN_SIWE: 'Sign in With Wallet to RedotPay Dapp.',
  TRANSANCT_LIMIT: 'Set transaction limit '
}

export enum CARD_STATUS {
  FROZEN = "FROZEN",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING ='PENDING',
}

export enum CARD_STRING_TYPE {
  VIRTUAL = 1,
  PHYSICAL = 2
}

export enum ASSET_LOG_STATUS {
  PROCESSING = 1,
  SUCCESS = 2,
  FAILED = 3,
}

export enum CARD_APPLY_STATUS {
  Pending,
  Processing,
  Success,
  Failed,
  Cancel,
  Unknown
}

export enum  CARD_TRANSACTION_TYPE {
  CARD_TRANSACTION = "CARD_TRANSACTION",
  REFUND = "REFUND",
  VISA_TRANSFER = "VISA_TRANSFER"
}

export enum CARD_TRANSACTION_SHOW_STATUS {
  PENDING = "PENDING",
  CLEARED = "CLEARED",
  REVERSAL = "REVERSAL",
  CLEARED_FULLY_REFUND = "CLEARED_FULLY_REFUND",
  CLEARED_PARTIAL_REFUND = 'CLEARED_PARTIAL_REFUND',
  DECLINED = "DECLINED",
  VOID = "VOID",
}

export const APP_STORE_IOS_URL = 'https://apps.apple.com/app/id6449689356';
export const APP_STORE_ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.redotpay';
export const REDOTPAY_APP_DEEP_LINK = 'redotpay://app.redotpay.com';
